/**
 * Titles and meta descriptions for the public marketing pages (build F9 and
 * Appendix A). Imported by the pages (via `useSEO`) and by the server's
 * initial-HTML SEO injection (`server/lib/feature-seo.ts`), so the two never drift.
 *
 * Rule (F9): every public page title ends with "· PadPulse for PadSplit hosts"
 * or uses an exact Appendix title.
 */
import {
  HOST_BASE_PRICE,
  TIER_STEPS_SHORT,
  TRIAL_DAYS,
} from "@/lib/marketing/pricing-copy";

export const BRAND_TITLE_SUFFIX = " · PadPulse for PadSplit hosts";

export function marketingTitle(name: string): string {
  return `${name}${BRAND_TITLE_SUFFIX}`;
}

export interface PageSeo {
  title: string;
  description: string;
  path: string;
}

/** A10 */
export const HOME_SEO: PageSeo = {
  title: "PadPulse for PadSplit hosts · Run more rooms with less work",
  description: `PadPulse connects to your PadSplit account and puts member messages, booking requests, maintenance, smart locks and your P&L in one place. ${HOST_BASE_PRICE} a property. ${TRIAL_DAYS}-day free trial, no card.`,
  path: "/",
};

/** A3 (tier ordinals derived from the pricing module; see copy-changes.md, D2). */
export const PRICING_SEO: PageSeo = {
  title: marketingTitle(`PadPulse pricing: ${HOST_BASE_PRICE} a property`),
   description: `Host plans from ${HOST_BASE_PRICE} a property a month, ${TIER_STEPS_SHORT}. AI-drafted replies require beta access. ${TRIAL_DAYS}-day free trial, no card.`,
  path: "/pricing",
};

/** A4 */
export const SIGNUP_SEO: PageSeo = {
  title: marketingTitle("Start your free trial"),
  description: `Start your ${TRIAL_DAYS}-day free trial of PadPulse. No card needed. Connect PadSplit in about 3 minutes.`,
  path: "/signup",
};

/** A5 (noindex) */
export const SYRE_SEO: PageSeo = {
  title: marketingTitle("SYRE lifetime deal"),
  description: "Scale Your Real Estate Mastermind lifetime deal for PadPulse.",
  path: "/syre",
};

export const SAVINGS_CALCULATOR_SEO: PageSeo = {
  title: marketingTitle("Savings calculator"),
  description: `Compare what your current software stack costs with PadPulse at ${HOST_BASE_PRICE} a property a month. ${TRIAL_DAYS}-day free trial, no card.`,
  path: "/savings-calculator",
};
